var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._b({attrs:{"type":"number","step":"0.1","min":"0","max":"100","value":_vm.percentage},on:{"change":_vm.updated},scopedSlots:_vm._u([{key:"prepend-inner",fn:function(){return [_vm._v("%")]},proxy:true}])},'v-text-field',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }